// removed by extract-text-webpack-plugin
module.exports = {"Register-Class-Modal-Content":"Register-Class-Modal-Content","react-tel-input":"react-tel-input","selected-flag":"selected-flag","flag":"flag"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/RegisterClassModal/Modal.scss
// module id = 1yZZ
// module chunks = 0